import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-market_def",
  "use": "icon-market_def-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-market_def\"><path d=\"M49.104425 901.677876h268.828318V469.720354l-73.628318-51.341593L49.104425 584.509735z m332.261947 0H650.19469V472.240708l-129.869026 109.253097-138.959292-75.525663zM713.628319 421.39469v480.283186h268.828318V424.410619l-114.761062-151.037168z\" p-id=\"5381\" /><path d=\"M93.451327 464.297345l146.20885-122.307964 279.306195 170.053097 331.284955-311.957522a37.168142 37.168142 0 0 0 3.185841-3.667257l55.787611 56.41062L999.065487 0l-257.699115 83.030088 61.677876 62.385841a27.695575 27.695575 0 0 0-2.463717 1.883186L509.536283 421.380531 233.047788 253.083186l-186.053098 155.610619A36.247788 36.247788 0 0 0 93.451327 464.297345zM976.424779 951.504425h-928.849558a36.247788 36.247788 0 0 0 0 72.495575h928.849558a36.247788 36.247788 0 0 0 0-72.495575z\" p-id=\"5382\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/market_def.svg
// module id = /A7l
// module chunks = 44